import { Component, Input } from '@angular/core';

import { AbstractControl, FormControl } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-form-error',
  imports: [TranslateModule],
  templateUrl: './form-error.component.html',
  styleUrls: ['./form-error.component.scss'],
})
export class FormErrorComponent {
  @Input() name: string;
  @Input() patternError = 'formErrors.invalid pattern';
  private _formControl: FormControl | AbstractControl;

  get control(): FormControl | AbstractControl {
    return this._formControl;
  }

  @Input()
  set control(form: FormControl | AbstractControl) {
    this._formControl = form;
  }
}
